import { ExternalLink, Server, MessageCircle, Cloud, Brain, Container, Database, Shield, GitBranch } from 'lucide-react'

const services = [
  { name: 'LobeHub', url: 'http://100.122.20.113:3210', icon: MessageCircle, desc: 'AI Chat Interface', status: 'live', color: 'text-aith-green' },
  { name: 'Portainer', url: 'https://100.122.20.113:9443', icon: Container, desc: 'Container Management', status: 'live', color: 'text-aith-green' },
  { name: 'Ollama API', url: 'http://100.122.20.113:11434', icon: Brain, desc: 'Local LLM Engine', status: 'live', color: 'text-aith-green' },
  { name: 'Nextcloud AIO', url: 'http://100.122.20.113:8080', icon: Cloud, desc: 'Office Suite', status: 'issue', color: 'text-aith-yellow' },
  { name: 'Cloudflare Workers', url: 'https://dash.cloudflare.com', icon: Server, desc: 'Vision Pillar', status: 'external', color: 'text-aith-cyan' },
  { name: 'AI Gateway', url: 'https://dash.cloudflare.com/ai-gateway', icon: Database, desc: 'Inference Routing', status: 'external', color: 'text-aith-cyan' },
  { name: 'DO Dashboard', url: 'https://dash.digitalocean.com', icon: Shield, desc: 'Stomach Pillar', status: 'external', color: 'text-aith-accent' },
  { name: 'GitHub', url: 'https://github.com/AiTH-Solutions', icon: GitBranch, desc: 'Hands Pillar', status: 'external', color: 'text-gray-300' },
]

export default function ServiceLinks() {
  return (
    <div className="space-y-6">
      <h2 className="text-xs font-bold tracking-widest text-gray-500 uppercase">Service Launcher</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {services.map((svc) => {
          const Icon = svc.icon
          return (
            <a
              key={svc.name}
              href={svc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="panel hover:border-aith-accent/50 hover:bg-gray-800/30 transition-all group flex flex-col"
            >
              <div className="flex items-start justify-between mb-3">
                <div className={`p-2 rounded bg-gray-800/50 ${svc.color}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <ExternalLink className="w-3.5 h-3.5 text-gray-600 group-hover:text-gray-400 transition-colors" />
              </div>
              <h3 className="text-sm font-bold text-white">{svc.name}</h3>
              <p className="text-[10px] text-gray-500 mb-2">{svc.desc}</p>
              <div className="mt-auto">
                {svc.status === 'live' && (
                  <span className="text-[10px] bg-aith-green/10 text-aith-green px-2 py-0.5 rounded-full">LIVE</span>
                )}
                {svc.status === 'issue' && (
                  <span className="text-[10px] bg-aith-yellow/10 text-aith-yellow px-2 py-0.5 rounded-full">ISSUE</span>
                )}
                {svc.status === 'external' && (
                  <span className="text-[10px] bg-gray-800 text-gray-400 px-2 py-0.5 rounded-full">EXTERNAL</span>
                )}
              </div>
            </a>
          )
        })}
      </div>
    </div>
  )
}
